import { render, staticRenderFns } from "./MomentsTemplates.vue?vue&type=template&id=1c9490c2&"
import script from "./MomentsTemplates.vue?vue&type=script&lang=js&"
export * from "./MomentsTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports